import React from "react"
import { Link } from "gatsby"

import NezamSenfi from './../images/footer/nezam-senfi.png'
import Logo from './../images/logo-simple.png'
import Arrow from './../images/icons/drop-down.png'
import Instagram from './../images/icons/instagram.png'
import Telegram from './../images/icons/telegram.png'
import Phone from './../images/icons/phone.png'
import Envelope from './../images/icons/envelope-silver.png'
import { useState } from "react"
import { validateEmail, apiCall } from "../../Helper"
import { toast } from "react-toastify"

export default () => {
  const [email, setEmail] = useState('')

  function submitNewsLetter(e) {
    e.preventDefault()
    if (validateEmail(email)) {
      // ready
      apiCall({
        url: '/adminPanel/newsLetter', method: 'post', data: { email }
      }).then(res => {
        if (res && res.data) {
          if (res.data.code === 0) {
            toast.success('ایمیل با موفقیت ثبت شد')
            setEmail('')
          } else if (res.data.code === 201)
            toast.error('ایمیل قبلا ثبت شده')
          else
            toast.error('مشکل در سیستم')
        } else toast.error('مشکل در سیستم')
      }).catch(err => toast.error('مشکل در سیستم'))
    } else toast.warn('فرمت ایمیل صحیح نمی باشد')
  }

  return (
    <footer className="pt-45">
      <div className="bg-footer">
        <div className="container text-top-nav p-64">
          <div className="grid" style={{ gridTemplateColumns: '1fr 1fr 2fr', gridGap: 45 }}>
            <div>
              <img src={Logo} alt="" style={{ padding: '0 36px 15px' }} />
              <p className="font-10 text-top-nav line-2">
                دیجی مالیات یعنی برنامه ریزی جامع ذهنی نوین برای ایجاد فرهنگ مدرن مالیاتی در جامعه مالی و مالیاتی کشور با بهره گیری از تکنولوژی های هوشمند آموزشی و بهره گیری از نرم افزارهای حرفه ای با پدید آوردن هوش مصنوعی در جهت خدمت به عام مردم .

                حیات و ممات هر جامعه ای به اقتصاد آن بستگی دارد و زمانی که حیات اقتصادی آن پویا...
              </p>
              <hr className="my-22" />
              <p className="font-10 text-top-nav">جهت دریافت خبرنامه لطفا ایمیل خود را وارد نمایید</p>
              <form className="grid radius-4 overflow-hidden" style={{ gridTemplateColumns: '1fr 4fr' }} onSubmit={submitNewsLetter}>
                <button className="bd-none iran-sans bg-bg">ثبت</button>
                <input type="text"
                  onChange={e => setEmail(e.target.value)} value={email}
                  className="bd-none text-top-nav px-8" style={{ height: 45, backgroundColor: 'rgba(237, 237, 237, 0.16)' }} />
              </form>
            </div>

            <div>
              <h5 className="text-shadow font-14 text-top-nav mt-0 pr-20">
                <img className="icon-xs ml-8" style={{ transform: 'rotate(90deg)' }} src={Arrow} alt="" />
                    دسترسی سریع
                  </h5>
              <ul style={{ listStyle: 'none' }}>
                <li className="pb-16">
                  <Link to="/" className="text-top-nav">خانه</Link>
                </li>
                <li className="pb-16">
                  <a href="/shop" className="text-top-nav">فروشگاه</a>
                </li>
                {/* <li className="pb-16">
                  <Link to="" className="text-top-nav text-semi-disabled">خدمات</Link>
                </li> */}
                <li className="pb-16">
                  <Link to="/faq" className="text-top-nav">سوالات متداول</Link>
                </li>
                <li className="pb-16">
                  <Link to="/about" className="text-top-nav">درباره ما</Link>
                </li>
                <li className="pb-16">
                  <Link to="/contact" className="text-top-nav">ارتباط با ما</Link>
                </li>
                <li className="pb-16">
                  <Link to="/library/laws" className="text-tomato">سامانه مالیاتی</Link>
                </li>
              </ul>
            </div>

            <div>
              <div className="w-50 inline-blocked">
                <h5 className="text-shadow font-14 text-top-nav mt-0">
                  <img className="icon-xs ml-8" style={{ transform: 'rotate(90deg)' }} src={Arrow} alt="" />
                      راه های ارتباطی
                    </h5>
                <ul className="pr-16" style={{ listStyle: 'none' }}>
                  <li className="pb-16">
                    <a dir="ltr" href="tel:00982191090130" className="text-top-nav">
                      <span className="bg-bg mr-8 icon-mask thumb-sm inline-blocked" style={{
                        WebkitMaskImage: `url(${Phone})`,
                        WebkitMaskSize: 'contain',
                        marginBottom: -4
                      }} />
                      021-91090130
                      </a>
                  </li>
                  <li className="pb-16">
                    <a dir="ltr" href="mailto:info@digimaliat.ir" className="text-top-nav font-10">
                      <span className="bg-bg mr-8 icon-mask thumb-sm inline-blocked" style={{
                        WebkitMaskImage: `url(${Envelope})`,
                        WebkitMaskSize: 'contain',
                        marginBottom: -4
                      }} />
                      info@digimaliat.ir
                      </a>
                  </li>
                </ul>
              </div>

              <div className="w-50 inline-blocked">
                <h5 className="text-shadow font-14 text-top-nav mt-0">
                  <img className="icon-xs ml-8" style={{ transform: 'rotate(90deg)' }} src={Arrow} alt="" />
                      ما در شبکه های اجتماعی
                    </h5>
                <ul className="pr-16" style={{ listStyle: 'none' }}>
                  <li className="pb-16">
                    <a className="text-top-nav" dir="ltr" href="https://instagram.com/digimaliat" target="_blank">
                      <span className="bg-bg mr-8 icon-mask thumb-sm inline-blocked" style={{
                        WebkitMaskImage: `url(${Instagram})`,
                        WebkitMaskSize: 'contain',
                        marginBottom: -4
                      }} />
                      @digimaliat
                    </a>
                  </li>
                  <li className="pb-16">
                    <a className="text-top-nav" dir="ltr" href="https://t.me/digimaliat" target="_blank">
                      <span className="bg-bg mr-8 icon-mask thumb-sm inline-blocked" style={{
                        WebkitMaskImage: `url(${Telegram})`,
                        WebkitMaskSize: 'contain',
                        marginBottom: -4
                      }} />
                      @digimaliat
                    </a>
                  </li>
                </ul>
              </div>

              <div className="flexed mt-32">
                <div className="px-8">
                  <div className="radius-8 flexed fl-c bg-top-nav-70 p-8" style={{ height: 150, width: 130 }}>
                    <img src={NezamSenfi} alt="" />
                  </div>
                </div>
                {/* <div className="px-8">
                  <div className="radius-8 flexed fl-c bg-top-nav-70 p-8" style={{ height: 150, width: 130 }}>
                    <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=194670&amp;Code=nsryPJEnzEf45gw7hJq5">
                      <img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=194670&amp;Code=nsryPJEnzEf45gw7hJq5" alt="" id="nsryPJEnzEf45gw7hJq5" /></a>
                  </div>
                </div> */}

                {
                  // [...Array(2)].map((item, i) => (
                  //   <div className="flex-1 px-8" key={i}>
                  //     {/* <img src={Avatar} alt="" /> */}
                  //     <div className="radius-8 flexed fl-c" style={{
                  //       width: 128, height: 150, backgroundColor: '#f1f1f1', backgroundImage: 'var(--purplegradbottom)',
                  //       color: '#989898'
                  //     }}>به زودی...</div>
                  //   </div>
                  // ))
                }
              </div>
            </div>
          </div>
        </div>

        <div className="p-16 text-center" style={{ background: '#fff4' }}>
          تمامی حقوق مادی و معنوی این سایت متعلق به
          <span className="text-tomato"> تحلیل گران عصر اندیشه <span className="font-10 text-tomato">(سهامی خاص)</span> </span>
          میباشد
        </div>
      </div>
    </footer >
  )
}
